/**
 * Player-facing lines for fleet action results (plan P27): the worker's M6 refusal codes, the Career's and the
 * panels' own. Pure.
 */

/** What a panel action did: `ok`, or a refusal code (the `fleet` service's `FleetOutcome`). */
export type ActionOutcome = { ok: true; createdId?: string } | { ok: false; error: string }

const TEXT: Readonly<Record<string, string>> = Object.freeze({
  unknownShip: 'That ship is no longer in the fleet.',
  unknownCaptain: 'That captain is no longer available.',
  unknownHull: 'This yard does not sell that hull.',
  unknownStation: 'Unknown station.',
  noFunds: 'Not enough credits.',
  insufficientFunds: 'Not enough credits.',
  capReached: 'The cap is reached.',
  standingTooLow: 'Your standing with the yard’s faction is too low.',
  noOwnership: 'Own the lease first.',
  notOwned: 'Insurance opens once the lease is owned.',
  notDocked: 'The ship must be docked.',
  notAllowed: 'Not possible here.',
  // M10 P4a3b: the shipyard's embargo (P5a2 names the faction and greys the row).
  embargo: 'Embargo: this yard’s owners won’t build for you.',
  // M10 P5a1b1: the player's hull gate (the shop names the missing steps).
  gateLocked: 'Locked: this hull’s gate is not met yet.',
  busy: 'The ship is busy.',
  // M10 P5a3b: ship names at purchase and `renameShip`.
  badName: 'A ship name is 1 to 24 characters.',
  nameTaken: 'Another ship in your fleet has that name.',
  notWired: 'Not available yet.',
  disposed: 'The fleet link is offline.',
  noFleet: 'The fleet link is offline.',
  // M9 (CH-12b): flaw fixes and scrapping a claimed ship (`hulks/restore.ts FLAW_FIX_REFUSAL_TEXT`, CH-7a's worker codes).
  noShip: 'That ship is not in your hangar.',
  noFlaw: 'That ship has no such flaw.',
  notYard: 'Only a station with a yard can do that.',
  goods: 'Your hold lacks the goods for this fix.',
  notClaimed: 'Only a claimed hull can be scrapped.',
  notRegistered: 'Not registered yet: it registers when it docks.',
  hulkUsed: 'That hulk is claimed already.',
  cargoFull: 'Not enough cargo space.',
  flown: 'You are flying it.',
})

/** The line for refusal `code`. */
export function errorText(code: string): string {
  return TEXT[code] ?? `Refused (${code}).`
}

/** The status line after an action: `okText` on success, else the refusal's line. */
export function outcomeText(r: ActionOutcome, okText: string): string {
  return r.ok ? okText : errorText(r.error)
}

/** A thrown error as a refusal (a broken link must not leave a panel busy). */
export function caught(err: unknown): ActionOutcome {
  return { ok: false, error: err instanceof Error ? err.message : String(err) }
}
